import firebase from "@firebase/app";
import { getConfig } from "../../../../config/app";

const isClient = () => typeof window !== "undefined";

let db = null;
let app = null;

if (isClient()) {
  require("@firebase/firestore");
  require("@firebase/storage");

  app = !firebase.apps.length
    ? firebase.initializeApp(getConfig("firebaseConfig"))
    : firebase.app();

  db = app.firestore();
}

export { db, app };
